/* eslint-disable @typescript-eslint/no-explicit-any */
import "./EmptyFlyoutPanel.css";

import { ReactNode } from "react";

import { Backdrop } from "../Backdrop";
import { useEmptyFlyoutPanel } from "./useEmptyFlyoutPanel";

interface EmptyFlyoutPanelProps {
  /**
   * @param show should be part of a state variable (eg. [show, setShow]) set in the parent page class
   */
  show: boolean;
  onClose: () => void;
  size: "ExtraSmall" | "Small" | "Medium" | "Large";
  contentChildren: ReactNode;
}

export const EmptyFlyoutPanel = ({
  show,
  onClose,
  size,
  contentChildren,
}: EmptyFlyoutPanelProps): JSX.Element | null => {
  const { flyoutPanelRefCallBack, onFlyoutPanelKeyDownHandle, showTransition } = useEmptyFlyoutPanel({
    show,
    onClose,
  });

  return show ? (
    <>
      <div
        ref={flyoutPanelRefCallBack}
        className={`EmptyFlyoutPanel ${size} ${showTransition ? "Open" : ""}`}
        role="button"
        onKeyDown={onFlyoutPanelKeyDownHandle}
        tabIndex={0}
      >
        {contentChildren}
      </div>
      <Backdrop show={show} />
    </>
  ) : null;
};
